import React from "react";

const VideosTent = ({ handleRedirect, tentSingle, arrow }) => {
  return (
    <>
      <div className="tent-wrapper videos-tent-wrapper">
        <img src={tentSingle} alt="" />
      </div>
      <div
        className="inside-tent-door-wrapper videos-tent-door-wrapper"
        onClick={() => {
          handleRedirect("/videos");
        }}
      >
        <img src={arrow} alt="" className="arrow-icon" />
      </div>
      <div className="videos-tent-text-wrapper"></div>
    </>
  );
};

export default VideosTent;
